var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfo20 = function SvgInfo20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info20_svg__clip0_450_27136)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 19.167C4.945 19.167.833 15.055.833 10S4.945.833 10 .833 19.167 4.945 19.167 10 15.055 19.167 10 19.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.417 7.5h-.834V15h.834V7.5zM10.417 5h-.834v.833h.834V5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info20_svg__clip0_450_27136"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgInfo20;